import { ModuleManager, SectionList } from "@module-system";

import ChatPanelVue from "./Components/ChatPanel.vue";
import ChatButtonVue from "./Components/ChatButton.vue";
import locales from "./locales";
import CommonConditions from "@lib/commonConditions";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Chat",
  version: "1.0.0",
  register() {
    const chatConfig = window.CONFIG?.CHAT ?? {};
    chatConfig.ENABLED = chatConfig.ENABLED ?? true;
    chatConfig.ORDER = chatConfig.ORDER ?? 30;

    ModuleManager.addLocales(locales, "Chat");

    ModuleManager.addViewModule({
      key: "chat-button",
      order: chatConfig.ORDER,
      section: SectionList.CallButtonsList,
      ViewComponent: ChatButtonVue,
      Condition: () => chatConfig.ENABLED && !CommonConditions.isSupervisor(),
    });

    ModuleManager.addViewModule({
      key: "chat-panel",
      order: 2,
      size: 500,
      tabTitle: "Chat",
      section: SectionList.CallRightPanel,
      ViewComponent: ChatPanelVue,
      Condition: () => chatConfig.ENABLED && !CommonConditions.isSupervisor(),
    });
  },
};
export default module;
